import {
  apiErrorSchema,
  authSuccessSchema,
  type AuthSuccess,
} from "@reelio/contracts";

export class ApiRequestError extends Error {
  readonly code: string;
  readonly fieldErrors?: Record<string, string[]>;

  constructor({
    code,
    message,
    fieldErrors,
  }: {
    code: string;
    message: string;
    fieldErrors?: Record<string, string[]>;
  }) {
    super(message);
    this.name = "ApiRequestError";
    this.code = code;
    this.fieldErrors = fieldErrors;
  }
}

export const getViewer = async (
  signal?: AbortSignal,
): Promise<AuthSuccess> => {
  const response = await fetch("/api/viewer", {
    credentials: "same-origin",
    signal,
  });

  let payload: unknown;
  try {
    payload = await response.json();
  } catch {
    throw new ApiRequestError({
      code: "unexpected_response",
      message: "Reelio returned an unexpected response.",
    });
  }

  if (!response.ok) {
    const parsedError = apiErrorSchema.safeParse(payload);
    if (parsedError.success) {
      throw new ApiRequestError(parsedError.data.error);
    }

    throw new ApiRequestError({
      code: "unexpected_response",
      message: "Reelio could not load your account.",
    });
  }

  return authSuccessSchema.parse(payload);
};
